import React from 'react';
import { Link } from 'react-router-dom';

// The logo image has a baked-in checkerboard around the emblem: cropping it to a circle hides it
export const LogoMark = ({ size = 36, className = '' }) => (
  <span
    className={`inline-block rounded-full overflow-hidden ring-1 ring-brand-500/30 flex-shrink-0 ${className}`}
    style={{ width: size, height: size }}
  >
    <img src="/eseky-logo.png" alt="" className="w-full h-full object-cover scale-[1.12]" />
  </span>
);

const Logo = () => (
  <Link to="/" className="flex items-center gap-2.5 group" aria-label="Eseky home">
    <LogoMark size={34} />
    <span className="text-lg font-extrabold tracking-tight text-ink-100 group-hover:text-white">Eseky</span>
  </Link>
);

export default Logo;
